import React from 'react';
import { FormSpy } from 'react-final-form';

import { useScrollTo } from '../../../libs/hooks';

export const FormErrorScrollComponent = React.memo(() => {
  const { scrollTo } = useScrollTo('.fr-message--error');

  return (
    <FormSpy
      subscription={{ modifiedSinceLastSubmit: true, submitFailed: true }}
      onChange={() => scrollTo()}
    />
  );
});

FormErrorScrollComponent.displayName = 'FormErrorScrollComponent';
